import { Alert, Box, Link, Typography } from '@mui/material';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import { Link as RouterLink } from 'react-router-dom';
import { HINT_SEVERITY_MAP } from '../utils/hintEngine';

/**
 * Componente de Dica Contextual
 * Exibe dicas inteligentes baseadas no contexto da página
 * 
 * @param {object} hint - Objeto com { type, icon, message, action: { label, link } }
 * @param {function} onActionClick - Callback quando não há link (ex: abrir modal)
 */
export default function ContextualHint({ hint, onActionClick = null }) {
  if (!hint) {
    return null;
  }

  const severity = HINT_SEVERITY_MAP[hint.type] || 'info';

  const accentColorBySeverity = {
    info: 'info.main',
    success: 'success.main',
    warning: 'warning.main',
    error: 'error.main',
  };

  const accentColor = accentColorBySeverity[severity] || 'info.main';

  const actionLabel = hint.action?.label;
  const actionLink = hint.action?.link;

  return (
    <Alert
      severity={severity}
      variant="outlined"
      icon={<LightbulbIcon sx={{ color: 'warning.main' }} />}
      sx={{
        borderRadius: 10,
        mb: 3,
        mx: 'auto',
        maxWidth: '90%',
        bgcolor: 'action.hover',
        borderLeftWidth: 3,
        borderLeftStyle: 'solid',
        borderLeftColor: accentColor,
        '& .MuiAlert-message': { width: '100%' },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          lineHeight: 1.6,
          fontSize: '1.1em',
        }}
      >
        <center>
          {hint.icon && (
            <Typography
              component="span"
              sx={{
                ml: 1,
                fontSize: '1.4em',
                lineHeight: 1,
                verticalAlign: 'baseline',
              }}
            >
              {hint.icon}
            </Typography>
          )}
          <Typography component="span" sx={{ fontWeight: 700 }}>
            
          </Typography>
          <Typography component="span" sx={{ ml: 1, fontSize: '1.0em' }}>
            {hint.message}
          </Typography>
          {actionLabel && (actionLink || onActionClick) && (
            <>
              {' '}
              {actionLink ? (
                <Link component={RouterLink} to={actionLink} underline="always">
                  {actionLabel}
                </Link>
              ) : (
                <Link component="button" type="button" onClick={onActionClick} underline="always">
                  {actionLabel}
                </Link>
              )}
            </>
          )}
        </center>
      </Typography>
    </Alert>
  );
}
